module.exports = __webpack_public_path__ + "assets/1e387139c4fae111f3ab3671d009de0f.mp3";